import { Module } from 'vuex'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { ModuleState, RootState } from './types'

const timeSlotModule: Module<ModuleState, RootState> = {
  actions,
  getters,
  mutations,
  state: {
    editOffer: null,
    now: new Date(),
    subscription: null,
    offers: [],
    uncaughtErrors: [],
  },
}

export { Action } from './actions'
export { Mutation } from './mutations'
export { Offer } from './types'
export default timeSlotModule
